import axios from "axios";
import queryString from "query-string";
import { getAccessToken } from "@helpers";

export const axiosRequest = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  headers: { "content-type": "application/json" },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosRequest.interceptors.request.use(async (config) => {
  const accessToken = await getAccessToken();
  return accessToken
    ? { ...config, headers: { Authorization: `Bearer ${accessToken}` } }
    : config;
});

axiosRequest.interceptors.response.use(
  (response) => {
    const { headers, data } = response;
    if (headers["x-pagination"])
      return { pagination: JSON.parse(headers["x-pagination"]), data };
    return data;
  },
  (error) => {
    const { status, data } = error.response;
    switch (status) {
      case 400:
        // TODO: Define what to do on 400
        break;
      case 401:
        // TODO: Define what to do on 401
        break;
      case 403:
        // TODO: Define what to do on 403
        break;
      case 408:
        // TODO: Define what to do on 408
        break;
      default:
        break;
    }
    throw data;
  }
);
